import React from "react";
import { Container, Navbar } from "react-bootstrap";
import { DONATION_LINK } from "../common";

/**
 * Footer component in Bootstrap.
 */
const AppFooter: React.FC<{}> = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Navbar bg="light" variant="light">
      <Container>
        <Navbar.Brand style={{ fontSize: "0.8em" }}>
          {" "}
          Copyright &copy; {currentYear} Brandon Liang{" "}
        </Navbar.Brand>
        <Navbar.Text style={{ fontSize: "0.8em" }}>
          Support my website by <a href={DONATION_LINK}>donating via Paypal!</a>
        </Navbar.Text>
      </Container>
    </Navbar>
  );
};

export default AppFooter;
